<template>
  <Layout>
    <div v-if="aupair">
      <div class="flex justify-between items-center pb-5">
        <button class="btn btn-purple back" @click.prevent="goBack()">
          <i class="material-icons align-middle text-4xl">arrow_back_ios</i>
        </button>

        <AddToFavorites
          v-if="!favoriteStatusChanging"
          v-on:set-favorite-status="setStatus"
          :promoProfileId="aupair.auPairPromoProfileId"
          :isFavorite="isAuPairOnFavoriteList(aupair.auPairPromoProfileId)"
        />
        <div v-else class="-mt-6 lg:mt-0 px-16">
          <ComponentLoading />
        </div>
      </div>

      <ChiCard>
        <ProfileContainer :aupair="aupair" />
      </ChiCard>
    </div>
    <ComponentLoading v-else />
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";
import ChiCard from "@/components/UI/ChiCard.vue";
import ProfileContainer from "@/components/AuPairs/AuPairProfileItems/ProfileContainer.vue";
import AddToFavorites from "@/components/AuPairs/AuPairProfileItems/AddToFavorites.vue";

export default {
  name: "AuPairProfile",
  props: ["id"],
  components: {
    Layout,
    ChiCard,
    ProfileContainer,
    AddToFavorites,
  },

  data() {
    return {
      aupair: null,
      isFavorite: false,
      favoriteStatusChanging: false,
    };
  },

  methods: {
    goBack() {
      window.history.back();
    },
    setStatus(status) {
      try {
        this.favoriteStatusChanging = true;
        api
          .post("/promotional/AuPairPromoProfiles/favorite", {
            active: status,
            auPairPromoProfileId: this.aupair.auPairPromoProfileId,
          })
          .then((r) => {
            if (r.status === 200) {
              this.$store.dispatch("getUser").then(() => {
                this.$toasted.global.notificate({
                  message: `Au Pair ${
                    status ? `added` : `removed`
                  } to your favorites list.`,
                  type: "success",
                });
                this.favoriteStatusChanging = false;
              });
            }
          });
      } catch (e) {
        this.favoriteStatusChanging = false;
        this.$toasted.global.notificate({
          message: `We could not complted this action.`,
          type: "error",
        });
      }
    },
    isAuPairOnFavoriteList(id) {
      if (this.$store.state.user.favoriteAuPairs.includes(id)) {
        this.isFavorite = true;
        return true;
      } else {
        this.isFavorite = false;
        return false;
      }
    },
  },
  created() {
    api.get(`/promotional/AuPairPromoProfiles/${this.id}`).then((r) => {
      this.aupair = r.data;
    });

    if (!window.localStorage.tipAuPairProfile) {
      this.$toasted.global.oneTime({
        message:
          "Use the yellow star on the top right corner to mark an Au Pair as a favorite. You can favorite as many profiles as you would like. View all favorited Au Pairs on your Favorites list using the top menu.",
        type: "info",
        source: "profile",
      });
    }
  },
};
</script>

<style scoped>
button.back {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-top: 5px;
}
</style>
